// extracted by mini-css-extract-plugin
export var drawerContent = "_2u-0";
export var valueBlock = "_2u-1";
export var valueBlockFrom = "_2u-2 _2u-1";
export var valueBlockTo = "_2u-3 _2u-1";